var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    height: "1em",
    width: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    transform: "matrix(-1 0 0 -1 384 512)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea5455",
    d: "M192 64C176.376 74.86 34.879 208.266 27.429 221.373v72.22c10.325.253 147.565-143.552 164.571-150.382c17.006 6.83 154.246 150.635 164.571 150.382v-72.22C349.121 208.266 207.624 74.859 192 64m0 154.406C176.376 229.266 34.879 362.672 27.429 375.78V448c10.325.254 147.565-143.551 164.571-150.383C209.006 304.448 346.246 448.253 356.571 448v-72.221C349.121 362.672 207.624 229.266 192 218.406"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnClaim);
export default __webpack_public_path__ + "static/media/unClaim.44cc6b43a99b3048be4ab0af918690b5.svg";
export { ForwardRef as ReactComponent };